<script lang="ts">
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { reformatUrlAndGetTargetValue } from "@shared/services/target_value_forward_urls";

  import type { Banner } from "@shared/types/Banner";

  export let banner: Banner;
  export let testId: string;

  const { trackMrcEvents, trackClick } = EventTracking;

  // height is responsive and can shrink by about a 3rd, so we cannot set height directly.
  // Setting min-height to 2/3 of the final height will help reduce jumpiness.
  const bannerStyle =
    banner.width && banner.width !== 3200
      ? `max-width: ${banner.width}px; min-height: ${banner.height * 0.66}px;`
      : "";

  // Check if internal, or carrot ad. Does not show for sponsored content paged
  const isExternalBanner: boolean = (banner.object_tracking_id || banner.ad_id || null) !== null;

  const showSponsoredLabel: boolean = isExternalBanner || banner.display_sponsored_label;

  const handleClick = (entities: any) => {
    if (banner.forward_url) {
      trackClick(null, entities);
    }
  };

  const { href, target } = reformatUrlAndGetTargetValue(banner.forward_url);
</script>

<TrackingContext let:trackingContext>
  <div class="fizz-flex-row fizz-justify-center">
    <div style={bannerStyle}>
      <a
        {href}
        {target}
        data-testid={testId}
        use:trackMrcEvents={[trackingContext.entities]}
        on:click={() => handleClick(trackingContext.entities)}
      >
        <picture>
          <img src={banner.image_url} alt={banner.image_alt_text} data-testid="banner-img" />
        </picture>
      </a>
      {#if showSponsoredLabel}
        <div class="fizz-flex-row fizz-justify-end" data-testid="banner-sponsored-label">
          <div class="fizz-text-small fizz-text-subdued">Sponsored</div>
        </div>
      {/if}
    </div>
  </div>
</TrackingContext>
